// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import OpenMaintenancePlan from '@deere/cps-it.warranty-model-factory/lib/open-maintenance-plan';

const PlanNameDropDown = props =>
    <select
        {...props}
    >
        <option value=''/>
        {
            props.list.map(plan =>
                <option
                    key={plan.planName}
                    value={plan.planName}
                >
                    {plan.planDescription}
                </option>
            )
        }
    </select>;

PlanNameDropDown.displayName = 'PlanNameDropDown';
PlanNameDropDown.propTypes = {
    className: PropTypes.string.isRequired,
    list: PropTypes.arrayOf(PropTypes.instanceOf(OpenMaintenancePlan)).isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired
};

export default PlanNameDropDown;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/plan-name-dropdown.js